import { observer } from 'mobx-react-lite'
import { Label, TextFieldWithLabel } from 'shared/ui'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { SendFromMulti } from 'widgets/SendFromMulti/SendFromMulti'
import { type GroupInboxFormStore } from 'pages/settings/pages/inboxes/pages/inboxesView/store/groupInboxFormStore'
import styles from './styles.module.scss'

type IGroupInboxModalContentProps = {
  store: GroupInboxFormStore
}

export const GroupInboxModalContent = observer(({ store }: IGroupInboxModalContentProps) => {
  const {
    getFormError,
    groupInboxName,
    setGroupInboxName,
    groupInboxDescription,
    setGroupInboxDescription,
    sendFromMultiStore,
  } = store

  const inboxesError = getFormError('inboxes') ?? ''
  return (
    <div className={styles.container}>
      <TextFieldWithLabel
        labelProps={{
          label: {
            text: 'Group inbox name',
          },
        }}
        textFieldProps={{
          value: groupInboxName,
          onChange: setGroupInboxName,
          InputProps: {
            placeholder: 'Enter inbox name',
          },
          error: !!getFormError('name'),
        }}
        leftActions={[
          makeTextFieldIcon({
            icon: 'inboxes2',
            fontSize: 16,
            color: 'var(--content-primary-tertiary)',
            margin: '0 0 0 4px',
          }),
        ]}
        errorBorder={Boolean(getFormError('name'))}
        errorMessage={getFormError('name')}
      />
      <TextFieldWithLabel
        labelProps={{
          label: {
            text: 'Group inbox description',
          },
        }}
        textFieldProps={{
          value: groupInboxDescription,
          onChange: setGroupInboxDescription,
          InputProps: {
            placeholder: 'Enter inbox description',
          },
          className: styles.description,
        }}
      />
      <div>
        <Label
          label={{
            text: 'Inboxes',
          }}
          marginBottom='4px'
        />
        {sendFromMultiStore && (
          <SendFromMulti
            store={sendFromMultiStore}
            width={432}
            triggerProps={{
              emptyPlaceholder: 'Select',
              selectedOptionsCount: 2,
              isShowIcon: false,
              shouldShowSelectedItems: false,
              showNumbersCount: false,
              hideNumbers: true,
              triggerInnerContentClassName: styles.selectedItem,
            }}
            rightActions={[makeTextFieldIcon({ icon: 'chevronDown' })]}
            textFieldPlaceholderProps={{
              className: styles.inboxPlaceholderWrap,
              variant: 'stroke',
              size: 'medium',
            }}
            dropdownProps={{
              placeholder: 'Search',
              propsDropdownList: {
                autoHeightMax: 224,
              },
            }}
            dropdownGroupProps={{
              showSelectAllButton: false,
              stylesWrap: {
                padding: '4px 4px 8px',
              },
            }}
            popperProps={{
              offset: [0, -42],
            }}
            error={inboxesError ? { message: inboxesError, placement: 'top' } : undefined}
          />
        )}
      </div>
    </div>
  )
})
